export function getAvatarUrl(firstName: string | null, lastName?: string | null): string {
  return `https://ui-avatars.com/api/?name=${firstName}+${lastName}&font-size=.4&background=random&bold=true&rounded=true&format=svg`
}
